<h2 mat-dialog-title style="color: #0061A2">
    {{title}}
</h2>
<form [formGroup]="workPlan" style="width: 100%; margin-top: 20px;" fxLayout="column" autocomplete="off" (ngSubmit)="onConfirm()">
    <div fxFlex="95%">
        <div fxFlex="100%" fxLayout="column">
            <div fxFlex="100" fxLayout="row" fxLayout.sm='column' fxLayout.xs='column'>
                <div fxFlex="30" fxFlex.sm='100' fxFlex.xs='100'>
                    <mat-form-field appearance="outline" style="width: 98%;">
                        <mat-label>Fecha</mat-label>
                        <input matInput  [matDatepicker]="picker1" formControlName="date">
                        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                        <mat-datepicker #picker1></mat-datepicker>
                        <mat-error id="required" *ngIf="workPlan.controls['date'].hasError('required')">
                            La fecha es
                            <strong>requerida</strong>
                        </mat-error>
                    </mat-form-field>
                </div>
                <div fxFlex="30" fxFlex.sm='100' fxFlex.xs='100'>
                    <mat-form-field appearance="outline" style="width: 99%;">
                        <mat-label>Monto</mat-label>
                        <input matInput placeholder="Monto" type="text" appOnlynumber
                            formControlName="amount" >
                    </mat-form-field>
                </div>
                <div fxFlex="40" fxFlex.sm='100' fxFlex.xs='100'>
                    <mat-form-field appearance="outline" style="width: 98%;">
                        <mat-label>Estado</mat-label>
                        <mat-select formControlName="status">
                            <mat-option *ngFor="let status of statusList" [value]="status.value">{{status.name}}
                            </mat-option>
                        </mat-select>
                        <mat-error id="required" *ngIf="workPlan.controls['status'].hasError('required')">
                            El estado es
                            <strong>requerido</strong>
                        </mat-error>
                    </mat-form-field>
                </div>
                   
            </div>
            <div fxFlex="100">
                <div fxFlex="100">
                    <mat-form-field appearance="outline" style="width: 99%;">
                        <mat-label>Comentario</mat-label>
                        <textarea matInput placeholder="Comentario"
                            formControlName="comment" rows="5"></textarea>
                    </mat-form-field>
                </div>  
            </div>
        </div>

    </div>
    <div fxFlex="100" fxLayoutAlign="end none">
        <button mat-flat-button color="primary" type="submit" style="margin-left: 10px;">Editar</button>
    </div>

</form>